import React from "react";
import classNames from "classnames";
import { Icon } from "../KeyComponents";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import Avatar from "../Avatar";

function MobileNavbar({ menu, user, profileLink, profilePage }) {
  const location = useLocation();
  return <div className="mobile-navbar">
    {menu.map((item, index) => {
      const isActive = location.pathname === item.href;
      return <MobileNavbarItem key={index} icon={item.icon} text={item.text} href={item.href} isActive={isActive} />;
    })}
    <Link to={profileLink} className={classNames("mobile-navbar__item", { active: profilePage })}>
      <div className="mobile-navbar__item-avatar">
        <Avatar src={user.image} type="image" size="sm" />
      </div>
      <div className="mobile-navbar__item-label">You</div>
    </Link>
  </div>;
}

MobileNavbar.propTypes = {
  menu: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  })).isRequired,
  user: PropTypes.shape({
    image: PropTypes.string.isRequired,
  }).isRequired,
  profileLink: PropTypes.string.isRequired,
};

MobileNavbar.defaultProps = {
  menu: [],
};

function MobileNavbarItem({ icon, text, href, isActive }) {
  return (
    <Link to={href} className={classNames("mobile-navbar__item", { active: isActive })} role="link" tabIndex={0} >
      <Icon icon={icon} type="line" size="lg" />
      <div className="mobile-navbar__item-label">{text}</div>
    </Link>
  );
}

MobileNavbarItem.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
};

MobileNavbarItem.defaultProps = {
  isActive: false,
};

export default MobileNavbar;